import React from 'react';
import { BaseScaleView, useFramework } from '@/framework';
import { ILayerProps } from '@/version-types';
import { DrawPenCursor } from '../components/draw-pen-cursor';
import { DrawPenPath } from '../components/draw-pen-path';
import { useEliminateDraw } from '../hooks/use-draw';
import { useEliminateInit } from '../hooks/use-init';
import { useEliminatePenState } from '../states/eliminate-pen-state';
import { RenderWrapper } from './render-wrapper';

export const EliminatePen: React.FC<{ originLayer: ILayerProps; originIndex: number }> = ({
    originLayer,
    originIndex,
}) => {
    useEliminateInit();
    const framework = useFramework();
    // 裁剪区域属于画布；主图偏移和旋转只在内层应用，避免覆盖层重复变换。
    const frameBounds = framework.service.frame.getBaseInfo(originIndex);
    const imageLayer = {
        ...originLayer,
        left: originLayer.left - frameBounds.left,
        top: originLayer.top - frameBounds.top,
    };
    const eliminateConfig = useEliminatePenState()((state) => state.eliminateConfig);
    const {
        watermarkMaskURL,
        textMaskURL,
        autoRecognizeWatermark,
        autoRecognizeText,
        isWatermarkMaskUsed,
        isTextMaskUsed,
    } = eliminateConfig;
    const { drawPenType, penCursorSize, penVisible, drawingPath, drawPathList, mousePosition } = useEliminateDraw();

    /* ATTENTION: 统一在外层进行缩放，内部按照实际尺寸进行绘制 */
    return (
        <BaseScaleView layer={frameBounds} style={{ overflow: 'hidden' }}>
            <RenderWrapper layer={imageLayer}>
                <DrawPenPath
                    drawingPath={drawingPath}
                    drawPathList={drawPathList}
                    watermarkMaskURL={autoRecognizeWatermark && !isWatermarkMaskUsed ? watermarkMaskURL : ''}
                    textMaskURL={autoRecognizeText && !isTextMaskUsed ? textMaskURL : ''}
                />
            </RenderWrapper>
            <DrawPenCursor
                show={penVisible}
                size={penCursorSize}
                penType={drawPenType}
                position={{ x: mousePosition.x - frameBounds.left, y: mousePosition.y - frameBounds.top }}
            />
        </BaseScaleView>
    );
};
